//Vistas del main layout:
// import DefaultView from '../../../views/Dev';

import AuditView from '../../../views/AuditView';
import UsersManagement from '../../../views/UsersManagement';
import ProcessesRegistry from '../../../views/ProcessesRegistry';
import DownloadSourcesResume from '../../../views/DownloadSourcesResume';
import DownloadSourcesConfiguration from '../../../views/DownloadSourcesConfiguration';

let mainMenuRoutes = [
    // {
    //     path: "/dashboard",
    //     name: "Dashboard",
    //     subname: "Dashboard",
    //     icon: "nc-icon nc-chart-pie-36",
    //     component: DefaultView,
    //     layout: "/admin"
    // },
    {
        path: "/sources",
        name: "Fuentes",
        subname: "Fuentes de descarga",
        icon: "nc-icon nc-book-bookmark",
        component: DownloadSourcesResume,
        layout: "/admin",
        adminRequired: false
    },
    {
        path: "/reportes",
        name: "Reportes",
        subname: "Reportes",
        icon: "nc-icon nc-single-copy-04",
        component: ProcessesRegistry,
        layout: "/admin",
        adminRequired: false
    },
    {
        path: "/auditoria",
        name: "Auditoría",
        subname: "Auditoría",
        icon: "nc-icon nc-zoom-split",
        component: AuditView,
        layout: "/admin",
        adminRequired: true
    },
    {
        path: "/seguridad",
        name: "Seguridad",
        subname: "Seguridad",
        icon: "nc-icon nc-touch-id",
        component: UsersManagement,
        layout: "/admin",
        adminRequired: false
    },
    {
        bottom: true,
        path: "/configuracion",
        name: "Configuración",
        subname: "Configuración",
        icon: "nc-icon nc-settings-gear-65",
        component: DownloadSourcesConfiguration,
        layout: "/admin",
        adminRequired: true
    }
];

export default mainMenuRoutes;
